<template>
    <div class="h-100 min-height">
        <div class="card">
            <div class="card-header">
                <h4 class="card-title my-0">Order Transactions</h4>
            </div>
            <div class="card-body">
                <div v-if="orderTransactions.length > 0" class="row mt-1">
                    <div v-for="transaction in orderTransactions" :key="transaction.id" class="row pl-3 pr-3">
                        <div class="col-xl-12 pr-3 pt-3 pb-3 border-top">
                            <span class="mb-1">
                                <badge type="default" style="margin-right: 0.25rem;">{{ transaction.id }}</badge>
                            </span>
                            <transaction-fraud-badge :markedAsFraud="transaction[ORDER_TRANSACTIONS.fields.markedAsFraud]"></transaction-fraud-badge>
                            <transaction-active-badge :active="transaction[ORDER_TRANSACTIONS.fields.isActive]"></transaction-active-badge>
                            <transaction-captured-badge :captured="transaction[ORDER_TRANSACTIONS.fields.isCaptured]"></transaction-captured-badge>
                        </div>
                        <div class="col-xl-4">
                            <p class="hint mb-0">Status</p>
                            <h6>{{ transaction[ORDER_TRANSACTIONS.fields.status] }}</h6>
                        </div>
                        <div class="col-xl-4">
                            <p class="hint mb-0">Created</p>
                            <h6>{{ formattedDate(transaction[ORDER_TRANSACTIONS.fields.createdAt]) }}</h6>
                        </div>
                        <div class="col-xl-4">
                            <p class="hint mb-0">Modified</p>
                            <h6>{{ formattedDate(transaction[ORDER_TRANSACTIONS.fields.modifiedAt]) }}</h6>
                        </div>
                        <div class="col-xl-4">
                            <p class="hint mb-0">AVS Response</p>
                            <el-popover effect="dark" placement="top" trigger="hover" width="360">
                                <div>
                                    {{ transaction[ORDER_TRANSACTIONS.fields.paymentProcessor][ORDER_TRANSACTIONS.paymentProcessor.responseReasonDescription] }}
                                </div>
                                <div slot="reference">
                                    <h6>{{ transaction[ORDER_TRANSACTIONS.fields.paymentProcessor][ORDER_TRANSACTIONS.paymentProcessor.AVSResponse] }}</h6>
                                </div>
                            </el-popover>
                        </div>
                        <div class="col-xl-12">
                            <p class="card-category mb-2 mt-2">Payment Details</p>
                        </div>
                        <div class="col-xl-4">
                            <p class="hint mb-0">Total</p>
                            <h6>${{ transaction[ORDER_TRANSACTIONS.fields.chargedTotal] }}</h6>
                        </div>
                        <div class="col-xl-4">
                            <p class="hint mb-0">Credit Card Number</p>
                            <h6>{{ transaction[ORDER_TRANSACTIONS.fields.card][ORDER_TRANSACTIONS.card.masked] }}</h6>
                        </div>
                        <div class="col-xl-4">
                            <p class="hint mb-0">Credit Card Type</p>
                            <h6>{{ transaction[ORDER_TRANSACTIONS.fields.card][ORDER_TRANSACTIONS.card.type] }}</h6>
                        </div>
                        <div class="col-xl-4">
                            <p class="hint mb-0">Name</p>
                            <h6>
                                {{ transaction[ORDER_TRANSACTIONS.fields.card][ORDER_TRANSACTIONS.card.billing][ORDER_TRANSACTIONS.billing.firstName] }}
                                {{ transaction[ORDER_TRANSACTIONS.fields.card][ORDER_TRANSACTIONS.card.billing][ORDER_TRANSACTIONS.billing.lastName] }}
                            </h6>
                        </div>
                        <div class="col-xl-4">
                            <p class="hint mb-0">Country</p>
                            <h6>{{ transaction[ORDER_TRANSACTIONS.fields.card][ORDER_TRANSACTIONS.card.billing][ORDER_TRANSACTIONS.billing.country] }}</h6>
                        </div>
                        <div class="col-xl-4">
                            <p class="hint mb-0">Zip</p>
                            <h6>{{ transaction[ORDER_TRANSACTIONS.fields.card][ORDER_TRANSACTIONS.card.billing][ORDER_TRANSACTIONS.billing.zip] }}</h6>
                        </div>
                    </div>
                </div>
                <p v-else>No transactions currently assigned on this store product</p>
            </div>
            <div class="card-footer border-top">
                <p v-if="orderTransactions.length === 1" class="mb-0">One Transaction Displayed</p>
                <p v-else class="mb-0">{{ orderTransactions.length }} Transactions Displayed</p>
            </div>
        </div>
    </div>
</template>

<script>
import { ORDER_TRANSACTIONS } from 'db'
import { Badge } from '@/components/UIComponents'
import TransactionActiveBadge from 'Shared/Badges/TransactionActiveBadge'
import TransactionCapturedBadge from 'Shared/Badges/TransactionCapturedBadge'
import TransactionFraudBadge from 'Shared/Badges/TransactionFraudBadge'
export default {
    components: {
        Badge,
        TransactionActiveBadge,
        TransactionCapturedBadge,
        TransactionFraudBadge
    },
    props: {
        orderTransactions: {
            type: [Array, Boolean],
            required: true
        }
    },
    data() {
        return {
            ORDER_TRANSACTIONS
        }
    },
    methods: {
        formattedDate(date) {
            return date
                ? new Date(date).toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: 'numeric',
                      day: 'numeric',
                      hour: 'numeric',
                      minute: 'numeric'
                  })
                : 'N/A'
        }
    }
}
</script>

<style lang="scss" scoped>
.id-sm {
    font-size: 0.8rem;
}
.min-height {
    min-height: 336px;
}
.col-xl-6 {
    margin-bottom: 0.5rem;
}
button.btn {
    margin: 2px 1px;
}
</style>
